/**
 * SOLID Review
 * S — Strong. One concern: what the Framework's `ClientStateView` socket degrades to when nothing is wired.
 * O — N/A — one constant, built from the empty stores.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. One constant.
 * D — Good. The Application's starting state and its session view; the port type it implements.
 */
import { EmptyClientState } from '../state/EmptyClientState';
import { ClientSessionProjector } from '../state/ClientSessionProjector';
import type { IPortClientStateView, TClientViewState } from './ClientStateView';

const EMPTY = new EmptyClientState();
const EMPTY_GAME = EMPTY.game(0);
/** Built once: `useSyncExternalStore` needs the same object back on every read. */
const EMPTY_VIEW: TClientViewState = { ...EMPTY_GAME, session: new ClientSessionProjector().viewOf(EMPTY_GAME, EMPTY.sessionHost()) };

/**
 * The view of NO table and NO session, which never changes and has nothing to subscribe to — what the
 * Framework's `ClientStateView` socket degrades to unwired: a component shows the empty table rather than
 * throwing (frontend strict-ports plan, FE6c). It is the real session view of the empty stores, so it cannot
 * drift from what a wired view shows before anything has happened.
 *
 * A PORT's default, so it sits with the ports (FE7): the Framework's holder may import `application/ports/`
 * and nothing else of the Application (`request-adapters-application-ports-only`). Its own file, not
 * `ClientStateView.ts`: the session view it is built from types itself by that file, and `no-circular`
 * counts type-only edges.
 */
export const NULL_CLIENT_VIEW: IPortClientStateView = {
  getSnapshot: () => EMPTY_VIEW,
  subscribe: () => () => undefined,
};
